import { type ReuseCandidate } from "../types";

// リユース候補の取得時オプション → グリッドのチェック列の逆変換。
// KYODOTANPOMOKUROKU_GENZAI 等の _GENZAI 系は「現在」列も併せてチェックする
export const FIELDS_BY_ZENBUJIKO_OPTION: Record<string, string[]> = {
  KYODOTANPOMOKUROKU: ["kyoutan"],
  KYODOTANPOMOKUROKU_GENZAI: ["kyoutan", "genzai"],
  SHINTAKUMOKUROKU: ["sintaku"],
  SHINTAKUMOKUROKU_GENZAI: ["sintaku", "genzai"],
  HEISATOUKIBO: ["requestClosureBook"],
};

/**
 * リユース候補配列から指定書類種別の候補をすべて取り出す。
 * 全部事項はオプション構成ごとに複数入り、取得日の新しい順に並んでいる
 * （全部事項以外は1件のみ）
 */
export const findCandidates = (
  candidates: ReuseCandidate[],
  pictureType: string
): ReuseCandidate[] =>
  candidates.filter((candidate) => candidate.pictureType === pictureType);

/** 指定書類種別のうち取得日が最新の候補 */
export const findCandidate = (
  candidates: ReuseCandidate[],
  pictureType: string
): ReuseCandidate | undefined =>
  candidates.find((candidate) => candidate.pictureType === pictureType);
